import React from 'react';
import { useStore } from 'effector-react';
import type { GeneralID, MediaType } from '@types';
import { getUrlByMediaType } from '@utils/urlMakers';
import { $audioPlayer } from '@stores/audioPlayerStores';
import ImgPause from './pause.png';
import ImgPlay from './play.png';

interface Props {
  id: GeneralID;
  mediaType: MediaType;
  src: string;
}

function AudioBtn({ id, mediaType, src }: Props) {
  const url = `${getUrlByMediaType(mediaType, src)}?apid=${id}`;
  const playingSrc = useStore($audioPlayer.$playingAudio);
  const imgSrc = playingSrc === url ? ImgPause : ImgPlay;
  return (
    <img
      src={imgSrc}
      className="ml-20 h-32 w-32 flex-shrink-0 cursor-pointer"
      draggable={false}
      onClick={(e) => {
        e.stopPropagation();
        $audioPlayer.playAudio(url, { loop: false });
      }}
      alt=""
    />
  );
}

export default AudioBtn;
